<template>
  <div class="detail-page">
    <div class="top-actions">
      <b-button variant="secondary" size="sm" @click="$router.push({ name: 'booking_customer_list_tbn' })">
        Back to bookings
      </b-button>
    </div>

    <div v-if="loading" class="loading-wrap">
      <b-spinner />
    </div>

    <div v-else-if="booking" class="detail-grid">
      <div class="detail-card">
        <h3>Booking {{ booking.booking_id }}</h3>
        <div class="line"><b>Status:</b> {{ booking.status }}</div>
        <div class="line"><b>Organization:</b> {{ booking.org_name || 'N/A' }}</div>
        <div class="line"><b>Contact:</b> {{ booking.contact_name || 'N/A' }}</div>
        <div class="line"><b>Route:</b> {{ booking.route_name || 'N/A' }}</div>
        <div class="line"><b>Pickup:</b> {{ booking.pickup_location || 'N/A' }}</div>
        <div class="line"><b>Dropoff:</b> {{ booking.dropoff_location || 'N/A' }}</div>
        <div class="line"><b>Vehicle:</b> {{ booking.vehicle_id || 'TBD' }}</div>
        <div class="line"><b>Driver:</b> {{ booking.driver_name || 'TBD' }}</div>
        <div class="line"><b>Driver phone:</b> {{ booking.driver_phone || 'N/A' }}</div>
        <div class="line"><b>Start:</b> {{ formatDateTime(booking.start_time) }}</div>
        <div class="line"><b>Finish:</b> {{ formatDateTime(booking.finish_time) }}</div>
      </div>

      <div class="map-card">
        <div class="map-title">Vehicle location</div>
        <div v-if="!primaryContactOrg" class="empty-card">Primary Contact Organization is required to load the fleet map.</div>
        <iframe
          v-else
          :src="fleetMapUrl"
          title="Fleet map"
          style="width: 100%; height: 65vh; border: 0; border-radius: 6px;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { tbn_get_booking_customer_detail } from '../networking/tbn_apis'

export default {
  name: 'booking_customer_detail_tbn',
  data() {
    return {
      loading: false,
      booking: null,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
    }),
    primaryContactOrg() {
      const fromBooking = this.booking && this.booking.org_name
      if (fromBooking) return String(fromBooking).trim()
      const list = this.user && this.user.allowed_primary_contact_orgs
      if (Array.isArray(list) && list.length) return list[0]
      const raw = this.user && this.user.primary_contact_organization
      if (!raw) return ''
      return String(raw).split(',')[0].trim()
    },
    fleetMapUrl() {
      const origin = window.location.origin
      const params = new URLSearchParams({
        tenant: this.user.tenant,
        mode: 'orgName',
        value: this.primaryContactOrg,
        tenantType: 'TBN',
      })
      return `${origin}/#/booking-customer-map?${params.toString()}`
    },
  },
  async created() {
    await this.loadData()
  },
  watch: {
    '$route.params.tbn_booking_hash': {
      async handler() {
        await this.loadData()
      },
    },
  },
  methods: {
    formatDateTime(value) {
      if (!value) return 'N/A'
      return new Date(value).toLocaleString()
    },
    async loadData() {
      const bookingHash = this.$route.params.tbn_booking_hash
      if (!bookingHash) return
      try {
        this.loading = true
        const { value: { data = {} } } = await tbn_get_booking_customer_detail(this.user.tenant, bookingHash)
        this.booking = data.booking || null
      } catch (e) {
        this.$emit('showAlert', 'Unable to load booking details. Please try again.', 'danger', 5000)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.detail-page { margin: 16px; }
.top-actions { text-align: left; margin-bottom: 10px; }
.detail-grid { display: grid; grid-template-columns: 0.95fr 1.05fr; gap: 12px; }
.detail-card, .map-card, .empty-card { border: 1px solid #d9dce3; border-radius: 8px; background: white; padding: 12px; text-align: left; }
.detail-card h3 { margin-top: 0; }
.line { margin-bottom: 6px; font-size: 14px; }
.map-title { font-weight: 700; margin-bottom: 8px; }
.loading-wrap { padding: 24px; }
@media (max-width: 1100px) {
  .detail-grid { grid-template-columns: 1fr; }
}
</style>
